<template>
    <div class="dialog_left">
        <div class='mes_line'>
            <mesLine :mesData='dialogData.right_chars_data'></mesLine>
        </div>
        <div class='map_location'>
            <span class='location_title'>设备数据</span>
            <listable class="listtable" :deviceDataList="dialogData.infodata.data" ></listable>

        </div>
    </div>
</template>

<script>
    import AMap from 'AMap'
    import {mapState, mapMutations} from 'vuex'
    import mesLine from '../chart/mes_line'
    import presLine from '../chart/pres_line.vue'
    import listable from './table_devdata_list.vue'

    var map
    export default {
        name: 'dialog_left',
        props: {
            dialogData: {
                type: Object
            },
            productType: {
                type: Number,
                default: ''
            }
        },
        data () {
            return {
              
            }
        },
        components: {
            mesLine,
            presLine,
            listable
        },
        watch: {
           
        },
        mounted () {
        },
        computed: {},
        methods: {
           
        }
    }
</script>
<style scoped lang='less'>
    .dialog_left {
        width: 100%;
        height: 100%;
        .mes_line {
            position: relative;   
            height: 50%;
            width: 100%;

        }

        .map_location {
            position: relative;   
            height: 50%;
            width: 100%;
            // background-color: rgb(63, 206, 87);
            .listtable {
                padding: 50px 0 0 10px;
               position: absolute;
               height: 100%;
               width: 98%;
               bottom: 10px;
            }
            .location_title {
                font-size: 17px;
                color: #ffffff;
                margin-left: 10px;
                margin-right: 20px;


            }

            .location_icon {
                margin-left: 20px;
                margin-top: 20px;
            }

            .location_map {
                width: 200px;
                height: 200px;
                margin-left: 20px;
                margin-top: 15px;
                // background: url(../../../static/img/er_left.png) no-repeat;
                background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_left.png) no-repeat;
                background-size: contain;

                .maps {
                    position: relative;
                    top: 10px;
                }
            }

            .location_map_civilian, .location_map_industrial {
                width: 300px;
                height: 185px;
                margin-left: 20px;
                margin-top: 15px;
                // background: url(../../../static/img/er_left.png) no-repeat;
                background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_left.png) no-repeat;
                background-size: 100% 100%;

                .maps {
                    position: relative;
                    top: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog_left.vue